import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cx } from '../../../internal/cx.js';
import { VisuallyHidden } from '../../layout/visually-hidden/index.js';
function ExternalGlyph() {
    return (_jsx("svg", { "aria-hidden": true, focusable: false, width: "12", height: "12", viewBox: "0 0 16 16", fill: "none", stroke: "currentColor", strokeWidth: 1.75, strokeLinecap: "round", strokeLinejoin: "round", children: _jsx("path", { d: "M6.5 3.5h-3v9h9v-3M9.5 2.5h4v4M13.5 2.5 7 9" }) }));
}
/**
 * Text link. When `target="_blank"` it adds `rel="noopener noreferrer"`, an
 * external icon and a hidden "opens in a new tab" note.
 */
export const Link = forwardRef(function Link({ variant = 'inline', asChild = false, target, rel, className, children, ...rest }, ref) {
    const external = target === '_blank';
    const Comp = asChild ? Slot : 'a';
    return (_jsxs(Comp, { ref: ref, ...rest, target: target, rel: external ? cx(rel, 'noopener', 'noreferrer') : rel, "data-variant": variant, className: cx('mn-link', className), children: [children, external ? (_jsxs(_Fragment, { children: [_jsx("span", { className: "mn-link__external", children: _jsx(ExternalGlyph, {}) }), _jsx(VisuallyHidden, { children: " (opens in a new tab)" })] })) : null] }));
});
//# sourceMappingURL=link.js.map